@if (forecast$ | async) {
  <section class="forecast-header-card">
    <header class="header-wrapper">
      <div class="forecast-header-info">
        <div class="company-name">
          <p class="ticker">
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.COMPANY"
              entityField="ticker"
            >
              {{ (forecast$ | async)!.company.ticker }}
            </app-user-access>
          </p>
          <p class="name">
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.COMPANY"
              entityField="name"
            >
              {{ (forecast$ | async)!.company.name }}
            </app-user-access>
          </p>
          <p class="info">
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.COMPANY"
              entityField="sector"
            >
              {{ (forecast$ | async)!.company.sector }}
            </app-user-access>
            |
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="cap_category"
            >
              {{ (forecast$ | async)!.capCategory || '' | forecastCompanySize }}
            </app-user-access>
            {{ 'forecast.capCategoryShort' | translate }}
          </p>
        </div>

        <mat-divider [vertical]="true"></mat-divider>

        <div class="eps eps-forecast">
          <p class="eps-value">
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="eps_forecast_proximilar"
            >
              {{ (forecast$ | async)!.epsForecastProximilar | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
          <p class="eps-info">{{ 'forecast.epsForecastProximilar' | translate }}</p>
        </div>

        <div class="eps eps-revenue">
          <p class="eps-value">
            <app-user-access
              [sectionName]="guardSectionName"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="sales_forecast_proximilar"
            >
              {{ (forecast$ | async)!.salesForecastProximilar | forecastNumber: -1 : true }}
            </app-user-access>
          </p>
          <p class="eps-info">{{ 'forecast.salesForecastProximilar' | translate }}</p>
        </div>
      </div>

      @if (showHomePageLink) {
        <a routerLink="/" mat-icon-button class="close-link" [title]="'common.close' | translate">
          <mat-icon>close</mat-icon>
        </a>
      }
    </header>
  </section>
}

@if (forecast$ | async) {
  <mat-divider></mat-divider>
  <section class="forecast-header-card">
    <header class="header-wrapper">
      <app-user-access
        [sectionName]="guardSectionName"
        [entityName]="EGuardEntityName.FORECAST"
        entityField="is_earning_release"
      >
        <div class="forecast-announce-info">
          <i class="earning-release" [class.release-soon]="(forecast$ | async)!.isEarningRelease"></i>

          @if ((forecast$ | async)!.isEarningRelease) {
            <span class="announce-title release-soon">
              <app-user-access
                [sectionName]="guardSectionName"
                [entityName]="EGuardEntityName.FORECAST"
                entityField="qrtr_end_date"
              >
                {{
                  'forecastInfo.announceExpired.announcingEndingSoon'
                    | translate: { endDate: (forecast$ | async)!.qrtrEndDate }
                }}
              </app-user-access>
            </span>
          }
          @if (!(forecast$ | async)!.isEarningRelease) {
            <span class="announce-title">
              <app-user-access
                [sectionName]="guardSectionName"
                [entityName]="EGuardEntityName.FORECAST"
                entityField="qrtr_end_date"
              >
                {{
                  'forecastInfo.announceExpired.willPublishNextQuarterMessage'
                    | translate: { date: announceDate | date: 'yyyy-MM-dd' }
                }}
              </app-user-access>
            </span>
          }
        </div>
      </app-user-access>
    </header>
  </section>
}

<mat-divider></mat-divider>
